import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUserTaxInfo } from './user-tax-info.transformers';
import type { UserTaxInfoCollection } from './user-tax-info.types';

const USER_TAX_INFO = 'userTaxInfo';

export function userTaxInfoReducer(
  state: CollectionStateSlice<UserTaxInfoCollection> = {},
  action: CollectionActions<UserTaxInfoCollection>,
): CollectionStateSlice<UserTaxInfoCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === USER_TAX_INFO) {
        const { result, ref, order } = action.payload;

        return mergeDocuments<UserTaxInfoCollection>(
          state,
          transformIntoDocuments(result.taxes, transformUserTaxInfo),
          order,
          ref,
        );
      }

      return state;

    case 'API_PUSH_SUCCESS':
      if (action.payload.type === USER_TAX_INFO) {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<UserTaxInfoCollection>(
          state,
          transformIntoDocuments([result], transformUserTaxInfo),
          ref,
        );
      }

      return state;

    case 'API_SET_SUCCESS':
      if (action.payload.type === USER_TAX_INFO) {
        const { ref, result, originalDocument } = action.payload;

        const newState = removeDocumentById<UserTaxInfoCollection>(
          ref,
          state,
          originalDocument.id,
        );

        return mergeWebsocketDocuments<UserTaxInfoCollection>(
          newState,
          transformIntoDocuments([result], transformUserTaxInfo),
          ref,
        );
      }

      return state;

    case 'API_DELETE_SUCCESS':
      if (action.payload.type === USER_TAX_INFO) {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById(ref, state, originalDocument.id);
      }

      return state;

    default:
      return state;
  }
}
